import apiBaseUrl from '../../utils/config.js';

class DoctorInfoService {
  constructor() {
    this.baseUrl = `${apiBaseUrl}/doctorinfo`;
  }

  getToken() {
    return localStorage.getItem("jwt");
  }

  getAuthHeaders() {
    const token = this.getToken();
    return {
      'Content-Type': 'application/json',
      ...(token && { Authorization: `Bearer ${token}` }),
    };
  }

  // ✅ Register doctor credentials (admin-only access)
  async registerDoctor(registerData) {
    const response = await fetch(`${this.baseUrl}/doctor/register/credentials`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(registerData),
    });

    if (!response.ok) {
      const errorText = await response.text();
      throw new Error(`Registration failed: ${errorText}`);
    }

    return await response.json();
  }

  // ✅ Doctor login
  async loginDoctor(loginData) {
    const response = await fetch(`${this.baseUrl}/doctor/login`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(loginData),
    });

    if (!response.ok) {
      const errorText = await response.text();
      throw new Error(`Login failed: ${errorText}`);
    }

    const result = await response.json();
    localStorage.setItem("jwt", result.token);
    localStorage.setItem("username", result.username);
    return result;
  }

  // ✅ Update doctor details
  async updateDoctorDetails(doctorId = null, username = null, details) {
    const queryParams = new URLSearchParams();
    if (doctorId !== null) queryParams.append('doctorId', doctorId);
    if (username !== null) queryParams.append('username', username);

    const response = await fetch(`${this.baseUrl}/update/details?${queryParams.toString()}`, {
      method: 'PUT',
      headers: this.getAuthHeaders(),
      body: JSON.stringify(details),
    });

    if (!response.ok) {
      const errorText = await response.text();
      throw new Error(`Update failed: ${errorText}`);
    }

    return await response.json();
  }

  // ✅ Update doctor account credentials (username and password)
async updateDoctorAccount(doctorId, newUsername, newPassword) {
  const response = await fetch(`${this.baseUrl}/update-account?doctorId=${doctorId}`, {
    method: 'PUT',
    headers: this.getAuthHeaders(),
    body: JSON.stringify({ username: newUsername, password: newPassword }),
  });

  if (!response.ok) {
    const errorText = await response.text();
    throw new Error(`Account update failed: ${errorText}`);
  }

  return await response.json(); // returns { message: "...success msg..." }
}


  // ✅ Fetch all doctors
  async getAllDoctors() {
    const response = await fetch(`${this.baseUrl}/doctor/all/details`, {
      headers: this.getAuthHeaders(),
    });

    if (!response.ok) {
      throw new Error('Failed to fetch doctors');
    }

    return await response.json();
  }

  // ✅ Fetch single doctor by ID
  async getDoctorById(id) {
    const response = await fetch(`${this.baseUrl}/${id}`, {
      headers: this.getAuthHeaders(),
    });

    if (!response.ok) {
      throw new Error(`Doctor with ID ${id} not found`);
    }

    return await response.json();
  }

  // ✅ Fetch doctor by username
  async getDoctorByUsername(username) {
    const response = await fetch(`${this.baseUrl}/doctor/by-username/${username}`, {
      headers: this.getAuthHeaders(),
    });

    if (!response.ok) {
      throw new Error(`Doctor with username "${username}" not found`);
    }

    return await response.json();
  }
}

export default DoctorInfoService;
